let imagePickHandler = null;
let pendingNativePick = false;
let nativePickTimer;
function getAppWindow() {
    return window;
}
function payloadToFile(payload) {
    if (typeof payload === 'string') {
        const value = payload.trim();
        if (!value)
            return null;
        if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('blob:')) {
            return null;
        }
        const mimeType = value.startsWith('data:')
            ? value.slice(value.indexOf(':') + 1, value.indexOf(';')) || 'image/jpeg'
            : 'image/jpeg';
        const base64 = value.includes(',') ? value.split(',')[1] : value;
        return base64ToFile(base64, mimeType);
    }
    const mimeType = payload.mimeType || 'image/jpeg';
    const fileName = payload.fileName || (mimeType.includes('png') ? 'image.png' : 'image.jpg');
    if (payload.base64) {
        return base64ToFile(payload.base64, mimeType, fileName);
    }
    if (payload.dataUrl) {
        return payloadToFile(payload.dataUrl);
    }
    return null;
}
function base64ToFile(base64, mimeType, fileName = 'image.jpg') {
    try {
        const normalized = base64.includes(',') ? base64.split(',')[1] : base64;
        const binary = atob(normalized);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i += 1) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new File([bytes], fileName, { type: mimeType });
    }
    catch {
        return null;
    }
}
function finishNativePick() {
    pendingNativePick = false;
    if (nativePickTimer) {
        clearTimeout(nativePickTimer);
        nativePickTimer = undefined;
    }
}
function dispatchPickedFile(file) {
    finishNativePick();
    if (file && imagePickHandler) {
        imagePickHandler(file);
    }
}
function handleNativeImagePayload(payload) {
    const file = payloadToFile(payload);
    if (file) {
        dispatchPickedFile(file);
        return;
    }
    const url = typeof payload === 'string' ? payload : payload.url;
    if (url && /^https?:\/\//.test(url)) {
        finishNativePick();
        void fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
            const type = blob.type || 'image/jpeg';
            const file = new File([blob], type.includes('png') ? 'image.png' : 'image.jpg', { type });
            imagePickHandler?.(file);
        })
            .catch(() => {
            // ignore fetch errors
        });
    }
}
function postIosMessage(name, message) {
    const handler = getAppWindow().webkit?.messageHandlers?.[name];
    if (!handler)
        return false;
    handler.postMessage(message);
    return true;
}
/** App 选图完成后调用：window.__CS_ON_IMAGE_PICKED__(base64 或 { base64, mimeType }) */
export function installAppImageBridge() {
    const win = getAppWindow();
    win.__CS_ON_IMAGE_PICKED__ = handleNativeImagePayload;
    win.onCsImagePicked = handleNativeImagePayload;
    win.onChooseImageResult = handleNativeImagePayload;
}
export function registerAppImageHandler(handler) {
    imagePickHandler = handler;
}
export function hasAppMediaBridge() {
    const win = getAppWindow();
    return !!(win.android?.chooseImage ||
        win.android?.pickImage ||
        win.android?.openGallery ||
        win.android?.openAlbum ||
        win.android?.openCamera ||
        win.android?.takePhoto ||
        win.QXApp?.chooseImage ||
        win.QXApp?.pickImage ||
        win.QXApp?.openGallery ||
        win.QXApp?.openAlbum ||
        win.QXApp?.openCamera ||
        win.QXApp?.takePhoto ||
        win.webkit?.messageHandlers?.chooseImage ||
        win.webkit?.messageHandlers?.pickImage ||
        win.webkit?.messageHandlers?.openGallery ||
        win.webkit?.messageHandlers?.openAlbum ||
        win.webkit?.messageHandlers?.openCamera ||
        win.webkit?.messageHandlers?.takePhoto);
}
/** 尝试走 App 原生相册/相机，成功返回 true */
export function requestAppMedia(source) {
    const win = getAppWindow();
    const album = source === 'gallery';
    const sourceArg = album ? 'album' : 'camera';
    finishNativePick();
    pendingNativePick = true;
    nativePickTimer = setTimeout(() => {
        pendingNativePick = false;
        nativePickTimer = undefined;
    }, 60000);
    if (album && win.android?.openGallery) {
        win.android.openGallery();
        return true;
    }
    if (album && win.android?.openAlbum) {
        win.android.openAlbum();
        return true;
    }
    if (!album && win.android?.openCamera) {
        win.android.openCamera();
        return true;
    }
    if (!album && win.android?.takePhoto) {
        win.android.takePhoto();
        return true;
    }
    if (win.android?.chooseImage) {
        win.android.chooseImage(sourceArg);
        return true;
    }
    if (win.android?.pickImage) {
        win.android.pickImage(sourceArg);
        return true;
    }
    if (album && win.QXApp?.openGallery) {
        win.QXApp.openGallery();
        return true;
    }
    if (album && win.QXApp?.openAlbum) {
        win.QXApp.openAlbum();
        return true;
    }
    if (!album && win.QXApp?.openCamera) {
        win.QXApp.openCamera();
        return true;
    }
    if (!album && win.QXApp?.takePhoto) {
        win.QXApp.takePhoto();
        return true;
    }
    if (win.QXApp?.chooseImage) {
        win.QXApp.chooseImage(sourceArg);
        return true;
    }
    if (win.QXApp?.pickImage) {
        win.QXApp.pickImage({ source: sourceArg });
        return true;
    }
    const iosPayload = { source: sourceArg };
    if (album && postIosMessage('openGallery', iosPayload))
        return true;
    if (album && postIosMessage('openAlbum', iosPayload))
        return true;
    if (!album && postIosMessage('openCamera', iosPayload))
        return true;
    if (!album && postIosMessage('takePhoto', iosPayload))
        return true;
    if (postIosMessage('chooseImage', iosPayload))
        return true;
    if (postIosMessage('pickImage', iosPayload))
        return true;
    finishNativePick();
    return false;
}
export function isPendingNativePick() {
    return pendingNativePick;
}
